export const lang = {
    lang: null,
    checkLanguage: function () {
        this.lang = document.querySelector('html').getAttribute('lang');
        if (this.lang !== 'pl' && this.lang !== 'de') {
            this.lang = navigator.language.slice(0, 2);
        }
    }
};
